<div data-automation="edit-resource-account-modal">
  <div class="row">
    <div class="col-md-12">
      <ziro-text [fieldId]="'upn'"></ziro-text>
      <ziro-text [fieldId]="'displayName'"></ziro-text>
      <ziro-select [fieldId]="'voiceApplication'"></ziro-select>
    </div>
  </div>
</div>
